/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { Typography, Box, Button, IconButton, Tooltip } from '@mui/material';
import {
  ArrowForward
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import PageTabTitle from 'src/components/PageTabTitle';
import SuperAdmin from './SuperAdmin';
import ExploreDepartment, { Department } from 'src/pages/Dashboard/ExploreDepartment';
import ClerkDepartment from "src/assets/images/ClerkDepartment.png"
import EngineeringDepartment from "src/assets/images/EngineeringDepartment.png"
import PetDepartment from "src/assets/images/PetDepartment.png"
import PZDepartment from "src/assets/images/PZDepartment.png"
import ConstructionDepartment from "src/assets/images/ConstructionDepartment.png"

const Dashboard: React.FC = () => {
  const [isExploreDepartment, setExploreDepartment] = React.useState(false);
  const [currentDepartment, setCurrentDepartment] = React.useState<Department>();
  const townshipData = useSelector(
    (store: RootState) => store.township.townshipDetails
  );
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const isSuperAdmin = userDetails.UserRole === 'Super Admin';

  // handler to explore the respective department
  const exploreDepartment = (department) => {
    // now update the respective state
    setExploreDepartment(true);
    setCurrentDepartment(department);
  }

  // remove the existing location from local storage
  useEffect(() => {
    const hasExistingLocation = localStorage.getItem('existingLocation')
    if (hasExistingLocation) localStorage.removeItem('existingLocation')
  }, [])

  // handle image error
  const handleImageError = (e, department) => {
    const { DepartmentID } = department
    const image = DepartmentID === 1
      ? PZDepartment
      : DepartmentID === 2
        ? EngineeringDepartment
        : DepartmentID === 3
          ? ClerkDepartment
          : DepartmentID === 4
            ? PetDepartment
            : DepartmentID === 5
            ? ConstructionDepartment
            : ''
    e.target.src = image
  }

  return (
    <>
      {/* PageTitle component */}
      <PageTabTitle title="Dashboard" />
      {/* Main content block */}
      <Box px={{md: 3, xs: 1.5}} className="dashboard_container"
        sx={{ background: !isSuperAdmin ? 'linear-gradient(135deg, rgba(33, 150, 243, 0.95) 0%, rgba(33, 203, 243, 0.95) 100%)' : null, minHeight: 'calc(100vh - 72px)' }}>
        {isSuperAdmin &&

          <Box sx={{ py: 3, borderRadius: 2, boxShadow: 2 }}>
            <Box
              sx={{
                backgroundColor: 'white',
                borderRadius: 1,
                boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
                padding: 2,
              }}
            >
              <SuperAdmin />
            </Box>
          </Box>}

        {!isSuperAdmin && <>
          {!isExploreDepartment && <>
            <Box className="main" sx={{ pt: 3, borderRadius: 2, boxShadow: 2 }}>
              <Box
                sx={{
                  borderRadius: 1,
                  padding:{md: 2},
                }}
              >
                <Typography
                  variant="h5"
                  textAlign="center"
                  fontSize={{md: "xx-large", xs: "26px"}}
                  sx={{ color: 'white' }}
                >
                  Welcome to <br/>{townshipData?.name}
                </Typography>
                <Typography
                  variant="h6"
                  textAlign="center"
                  fontStyle={'italic'}
                  my={2}
                  sx={{ color: 'white' }}
                >
                  {townshipData?.tagLine}
                </Typography>
                <Typography
                  variant="h6"
                  textAlign="justify"
                  lineHeight={{xs: 1.4}}
                  my={1}
                  sx={{ color: 'white' }}
                >
                  {townshipData?.description}
                </Typography>
              </Box>
            </Box>

            <Box className="main">
              <ul className="cards">
                {townshipData?.departmentDetails?.map((department) => (
                  <li className="cards_item" key={department.DepartmentID}>
                    <Box className="card" sx={{cursor: 'pointer'}} onClick={() => exploreDepartment(department)}>
                      <Box className="card_image">
                        <img
                          src={department?.DepartmentImage}
                          alt='Department'
                          onError={(e) => handleImageError(e, department)}
                        />
                      </Box>
                      <Box className="card_content">
                        <h2 className="card_title">{department?.DepartmentName}</h2>
                        <p className="card_text view-more">
                          {department?.DepartmentDescription}
                        </p>
                      </Box>
                      <Box className='btn_container'>
                        <Button
                          variant="contained"
                          size="large"
                          endIcon={<ArrowForward />}
                          sx={{
                            backgroundColor: 'white',
                            color: '#2196F3',
                            width: '100%',
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
                            '&:hover': {
                              backgroundColor: '#f8f8f8',
                              transform: 'translate(2px)',
                              boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
                            },
                            transition: 'all 0.3s ease'
                          }}
                        >
                          Explore More
                        </Button>
                      </Box>
                    </Box>
                  </li>
                ))}
              </ul>
            </Box>
          </>
          }

          {/* // Now explore the selected department */}
          {isExploreDepartment &&
            <ExploreDepartment
              currentDepartment={currentDepartment}
              setExploreDepartment={setExploreDepartment}
            />
          }
        </>}
      </Box>
    </>
  );
};

export default Dashboard;
